// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--K8dmS";
export var logoEu = "logo-module--logoEu--Krohe";
export var logoText = "logo-module--logoText---18lZ";